<template>
	<div id="workflowExecutionCanvas">
		<el-container style="height: inherit">
			<el-aside style="height: inherit" width="440px">
				<workflowsExecutionList @executionClicked="load" />
			</el-aside>
			<el-main style="padding: 0px">
				<div class="canvas">
					<workflowCanvas
						v-if="workflow"
						:key="executionId"
						ref="workflowCanvas"
						:workflowObject="workflow"
						:readOnlyMode="true"
						:execution="execution"
					/>
				</div>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import workflowCanvas from "./workflowCanvas.vue";
import workflowsExecutionList from "./workflowsExecutionList.vue";
export default {
	components: { workflowsExecutionList, workflowCanvas },
	data() {
		return {
			executionId: null,
			workflow: null,
			execution: null,
		};
	},
	methods: {
		async load({ executionId, execution }) {
			if (this.executionId === executionId) {
				return;
			}
			const result = await this.httpHelper("RUNTIME", "GET", "logs/returnWorkflowExecution", { executionId });
			if (!result?.error) {
				this.execution = execution;
				this.executionId = executionId;
				this.workflow = result.response.workflow;
				this.$nextTick(() => {
					this.$nextTick(() => {
						this.$refs.workflowCanvas.loadWorkflow();
					});
				});
			} else {
				this.$notifyError(this, result.error);
			}
		},
	},
};
</script>

<style scoped>
#workflowExecutionCanvas {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	background-color: transparent;
	position: relative;
	z-index: 0;
}

.canvas {
	height: 100%;
	width: 100%;
}
</style>
